import { IPrescriptionPosition } from '@alberta/konexi-shared/dist/prescription/prescription-position';

export class PrescriptionPositionViewModel implements IPrescriptionPosition {
  productGroupId: string;
  contractId: string;
  articleId: string;
  isFlatCharge: boolean;
  applienceNo: string;
  pcnNo: string;
  name: string;
  description: string;
  quantity: number;
  unit: string;
  constructor() {}
}
